import { render } from "./Teaching.vue?vue&type=template&id=2683157d&scoped=true"
import script from "./Teaching.vue?vue&type=script&lang=js"
export * from "./Teaching.vue?vue&type=script&lang=js"

import "./Teaching.vue?vue&type=style&index=0&id=2683157d&lang=scss&scoped=true"

import exportComponent from "/root/Fnedu/build/build20250805.141732/dashboard/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2683157d"]])

export default __exports__